import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import html2canvas from 'html2canvas';
import JsBarcode from 'jsbarcode';
import jsPDF from 'jspdf';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, finalize } from 'rxjs';
import { PagamentoCreditoVM } from 'src/app/api/model/conta/pagamento/pagamentoVM';
import { PropostaCotacaoService } from 'src/app/api/module/erp/services/area-logada/proposta-cotacao/proposta.cotacao.service';
import { EntidadeConfig, EntidadeEnum } from 'src/app/api/module/erp/shared/enumerable/entidade.enum';
import { MetoPagamentoEnum } from 'src/app/api/module/erp/shared/enumerable/metodo-pagamento.enum';
import { PropostaExternaEnum } from 'src/app/api/module/erp/shared/enumerable/poposta-externa.enum';
import { TipoModalAssinaturaEnum } from 'src/app/api/module/erp/shared/enumerable/tipo-modal-assinatura';
import {
  TipoProduto_E_OperadoraComponent,
  TipoProduto_E_OperadoraEnum,
} from 'src/app/api/module/erp/shared/enumerable/tipo-produto.enum';
import { DocumentoUploadHelper } from 'src/app/api/module/erp/shared/helper/documento-upload-helper';
import { CompartilharDadosEntreComponentsService } from 'src/app/api/module/erp/shared/services/compartilhar-dados-entre-components.service';
import { ErrorLoggingService } from 'src/app/api/module/erp/shared/services/error-logs/error-logging.service';
import { TabNavigationService } from 'src/app/api/module/erp/shared/services/tab-navegation/tab-navegation.service';
import { DocumentoPropostaEntidadeService } from 'src/app/api/module/externo/services/proposta/documento.proposta.entidade.service';
import { PagamentopPropostaService } from 'src/app/api/module/externo/services/proposta/pagamento.proposta.service';

// Declaração de tipo para o SDK PagSeguro
declare global {
  interface Window {
    PagSeguro: {
      encryptCard: (config: {
        publicKey: string;
        holder: string;
        number: string;
        expMonth: string;
        expYear: string;
        securityCode: string;
      }) => {
        hasErrors: boolean;
        errors?: any[];
        encryptedCard: string;
      };
    };
  }
}
@Component({
  selector: 'app-proposta-pagamento',
  templateUrl: './proposta-pagamento.component.html',
  styleUrls: ['./proposta-pagamento.component.scss'],
})
export class PropostaPagamentoComponent implements OnInit, AfterViewInit {
  @ViewChild('modalDocFinal') modalDocFinal: any;
  @Output() isAnalisePagamentoChange = new EventEmitter<boolean>();
  @Input() isAnalisePagamento: boolean = false;
  @Input() dadosOperadoraDM!: any;
  @ViewChild('barcode', {static: false})
  barcode!: ElementRef<SVGSVGElement>;

  @Input() somenteLeituraStep: boolean = false;
  _metodoPagamento = MetoPagamentoEnum;
  modalRef?: BsModalRef;
  modalDocFinalRef?: BsModalRef;
  descTipoPagamento = '';
  cardFormCredito!: FormGroup;
  isFlipped = false;
  isFormSubmited = false;
  classTipoModal = '';
  ehCredito = false;
  ehBoleto = false;
  ehPIX = false;
  ehBB = false;
  mensgemTemporaria = '';
  isExpanded = false;
  dadosRecebidosDoBeneciarioVM: any;
  dadosProdutoVM!: {
    entidade: null;
    nomeProduto: null;
    operadora: null;
    cobertura: null;
    taxaAdesao: 0;
    totalDependentes: any | 0;
    valorTotalDependentes: any | 0;
    valorTitular: 0;
    valorTotal: 0;
  };
  pagamentocartaoCredito!: PagamentoCreditoVM;
  iframeBoleto!: SafeResourceUrl;
  documentoUpload: any;
  documentoValido!: boolean;
  arquivoAnterior!: File | null;
  arquivoOriginal!: File | null;
  uploadStatus!: string;
  formTouched: boolean = false;
  errorMessage: boolean = false;
  mensagemTempErroPagamento: any;
  _listaParcelasCartaoCredito: any[] = [];
  propostaEnum = PropostaExternaEnum;
  formaPagamentoSelecionada: any | null = null;
  objModalDocFinal: any;
  checkboxDocFinal: boolean = false;
  listaIdBeneficiarios = new Array<any>();
  idProposta: any;
  heOdonto: any;
  entidades = {
    // Saúde
    heUdemo: false,
    heUnimedFesp: false,
    heApase: false,

    heAbraWeb: false,
    heAbje: false,
    heAdservip: false,
    heAfuspen: false,
    heCpp: false,
    heCrosp: false,
    heSasp: false,
    heSindinutri: false,
    heTecnologos: false,
    heAastpj: false,

    // Odonto
    heUnimedOdonto: false,
    heUniOdonto: false,
    heOdontoPrev: false,
  };
  nomeEntidadeAbreviado: any;
  dadosBoleto: any;
  pixelsPorMilimetro!: number;

  constructor(
    private _router: Router,
    private toastr: ToastrService,
    private modalService: BsModalService,
    private fb: FormBuilder,
    private _compartilharDadosEntreComponentsService: CompartilharDadosEntreComponentsService,
    private _pagamentoPropostaService: PagamentopPropostaService,
    private _activeRoute: ActivatedRoute,
    private spinner: NgxSpinnerService,
    public sanitizer: DomSanitizer,
    private documentoPropostaEntidadeService: DocumentoPropostaEntidadeService,
    private documentoUploadHelper: DocumentoUploadHelper,
    private tabService: TabNavigationService,
    private _errorLoggingService: ErrorLoggingService,
    private _propostaCotacaoService: PropostaCotacaoService,
  ) {}

  ngOnInit(): void {
    this.criarFormCredito();
    this.receberDadosDoBeneficiario();
    this.listaParcelasCartaoCredito();
    this.buscarDadosPagamentoPorProposta();
    // this.dadosBoleto = {
    //  {
    //   "membershipFeeId": "766fc0f7-11d2-4538-a92b-08de472b1057",
    //   "codigoBanco": "341",
    //   "linhaDigitavel": "34191760070003041038538871970000213270000004159",
    //   "codigoBarras": "34192132700000041591760000030410383887197000",
    //   "nossoNumero": "00000304",
    //   "carteira": "176",
    //   "valorDocumento": "00000000000004159",
    //   "dataVencimento": "2026-01-15",
    //   "dataEmissao": "2026-01-05",
    //   "cedenteNome": "GEIA ADMINISTRADORA DE BENEFIC",
    //   "cedenteDocumento": "07867825000157",
    //   "sacadoNome": "PAGAMENTO",
    //   "sacadoDocumento": "23818252823",
    //   "sacadoEndereco": "Rua Clevelandia, 3",
    //   "sacadoBairro": "Cidade Patriarc",
    //   "sacadoCidadeUf": "São Paulo - SP",
    //   "sacadoCep": "03555050",
    //   "instrucoes": "3 | Instruções: 4",
    //   "membershipFee": {
    //     "proposalId": "e694163d-d8b8-4bb9-295e-08de472ace25",
    //     "issueDate": "2026-01-05T15:06:01.0772875",
    //     "paymentMethod": 1,
    //     "value": 41.59,
    //     "valueReceived": null,
    //     "creditsDate": null,
    //     "payersName": "PAGAMENTO",
    //     "observation": null,
    //     "pending": "",
    //     "correctPayment": true,
    //     "proposal": null,
    //     "filePath": null,
    //     "proposalStep": 14,
    //     "id": "766fc0f7-11d2-4538-a92b-08de472b1057",
    //     "createDate": "2026-01-05T15:06:01.0772897",
    //     "updateDate": null,
    //     "active": true
    //   },
    //   "id": "75434e09-b422-4ec3-1b20-08de472c3ebc",
    //   "createDate": "2026-01-05T12:06:01.0744345",
    //   "updateDate": null,
    //   "active": true
    // }
    // };
  }

  formatarLinhaDigitavel(linha: string): string {
    if (!linha) return '';
    return linha.replace(/(\d{5})(\d{5})(\d{5})(\d{6})(\d{5})(\d{6})(\d{1})(\d{14})/, '$1.$2 $3.$4 $5.$6 $7 $8');
  }

  ngAfterViewInit(): void {
    this.abrirModalDocumentoFinal();

    this.tentarGerarCodigoBarras();
  }

  private calcularPixelsPorMilimetro(): number {
    const elementoMedicao = document.createElement('div');
    elementoMedicao.style.position = 'absolute';
    elementoMedicao.style.width = '100mm';

    document.body.appendChild(elementoMedicao);

    const retangulo = elementoMedicao.getBoundingClientRect();

    document.body.removeChild(elementoMedicao);

    return retangulo.width / 100;
  }

  private tentarGerarCodigoBarras(): void {
    this.pixelsPorMilimetro = this.calcularPixelsPorMilimetro();
    JsBarcode('#barcode', this.dadosBoleto?.codigoBarras, {
      format: 'CODE128',
      height: 10 * this.pixelsPorMilimetro,
      width: 2.3,
      displayValue: false,
      background: '#ffffff',
      font: 'monospace',
      fontOptions: 'bold',
      fontSize: 19,
      lineColor: '#000000',
      margin: 5 * this.pixelsPorMilimetro,
      textMargin: 2 * this.pixelsPorMilimetro,
      textAlign: 'right',
      textPosition: 'top',
    });
  }

  criarFormCredito() {
    this.cardFormCredito = this.fb.group({
      cardNumber: [
        '',
        [
          Validators.required,
          Validators.pattern(/^(\d{4}\s){3}\d{4}$|^\d{4}\s\d{6}\s\d{5}$/),
          this.validarNumeroCartao.bind(this),
        ],
      ],
      expiry: ['', [Validators.required, Validators.maxLength(6)]],
      expirationYear: [''],
      expirationMonth: [''],
      securityCode: ['', [Validators.required, Validators.pattern(/^\d{3}$/)]],
      holderName: ['', [Validators.required]],
      installments: [''],
      cpfHolder: new FormControl('', [Validators.required, Validators.maxLength(14)]),
    });
  }

  onlyLettersAndSpaces(event: KeyboardEvent) {
    const char = String.fromCharCode(event.which);
    if (!/^[a-zA-Z\s]*$/.test(char)) {
      event.preventDefault(); // Impede a entrada de caracteres não permitidos
    }
  }
  public get heColaborador(): boolean {
    return this._router.url.includes('colaborador');
  }

  async gerarBoleto(templateModalFormaPagamento: TemplateRef<any>) {
    const propostaId = this._activeRoute.snapshot.paramMap.get('idProposta') || '';
    this._pagamentoPropostaService
      .gerarBoleto(propostaId)
      .pipe(
        finalize(() => {
          this.pararSpinner(1000);
        }),
      )
      .subscribe(
        (data: any) => {
          this.toastr.success('Boleto Gerado.');
          this.formaPagamentoSelecionada = this._metodoPagamento.BOLETO;
          this.dadosBoleto = data;
          // this.dadosBoleto.codigoBarras = data.codigoBarras.toString().replace(/\D/g, '');

          setTimeout(() => this.tentarGerarCodigoBarras(), 0);
          this.abrirModal(templateModalFormaPagamento);
        },
        (error: any) => {
          this.pararSpinner();
          this.toastr.error('Erro ao gerar o boleto.');
        },
      );
  }

  iniciarSpinner() {
    this.spinner.show();
  }
  pararSpinner(ms?: number) {
    return new Promise(resolve => {
      setTimeout(() => {
        this.spinner.hide();
        resolve(true);
      }, ms);
    });
  }

  selecionarFormaPagamento(templateModalFormaPagamento: TemplateRef<any>, forma: any) {
    this.ehCredito = false;
    this.ehBoleto = false;
    this.ehPIX = false;
    this.ehBB = false;
    this.formaPagamentoSelecionada = forma;

    this.iniciarSpinner();
    switch (forma) {
      case this._metodoPagamento.BOLETO:
        this.ehBoleto = true;
        this.descTipoPagamento = 'Pagamento via Boleto';
        this.classTipoModal = 'bg-info';
        this.gerarBoleto(templateModalFormaPagamento);
        break;
      case this._metodoPagamento.CREDITO:
        this.ehCredito = true;
        this.classTipoModal = 'bg-success';
        this.descTipoPagamento = 'Pagamento via Credito ';
        this.cardFormCredito.reset();
        this.abrirModal(templateModalFormaPagamento);
        this.pararSpinner(1000);
        break;
      case this._metodoPagamento.PIX:
        this.ehPIX = true;
        this.classTipoModal = 'bg-secundary';
        this.descTipoPagamento = 'Pagamento via PIX';
        this.abrirModal(templateModalFormaPagamento);
        this.pararSpinner(1000);
        break;

      case this._metodoPagamento.TED:
        this.ehBB = true;
        this.classTipoModal = 'bg-warning';
        this.descTipoPagamento = 'Banco do Brasil';
        this.abrirModal(templateModalFormaPagamento);
        this.pararSpinner(1000);
        break;
    }
  }

  private abrirModal(templateModalAlerta: TemplateRef<any>) {
    this.modalRef = this.modalService.show(templateModalAlerta, {
      class: 'modal-lg',
    });
  }

  voltar() {}

  anexarComprovante(templateModalComprovante: TemplateRef<any>) {
    this.modalRef = this.modalService.show(templateModalComprovante, {
      class: 'modal-lg',
    });
    this.documentoValido = false;
    this.arquivoOriginal = null;
    this.mensgemTemporaria = '';
  }

  async uploadDocumento(event?: Event) {
    // Guarda o arquivo original antes de abrir o seletor
    this.arquivoAnterior = this.arquivoOriginal || null;

    if (event) {
      // Se veio do input, chama diretamente a função de seleção
      this.onSelecionarArquivo(event);
    } else {
      // Caso contrário, cria um input dinamicamente
      const inputElement = document.createElement('input');
      inputElement.type = 'file';
      inputElement.accept = '.doc, .docx, .pdf, image/*';
      inputElement.addEventListener('change', async (event: Event) => {
        await this.onSelecionarArquivo(event);
      });
      inputElement.click();
    }
  }

  enviarArquivoUploaded() {
    this.iniciarSpinner();

    // Cria o objeto de documento
    const documentoVM = this.criarDocumentoVM();

    // Valida se o arquivo foi carregado
    if (!this.arquivoOriginal) {
      this.toastr.warning('Nenhum documento carregado!');
      this.pararSpinner();
      return;
    }
    this.enviarComprovanteBancario(documentoVM);
  }

  criarDocumentoVM() {
    return {
      proposalId: this._activeRoute.snapshot.paramMap.get('idProposta') || '',
      documentType: 14, //comprovante bancario
      paymentMethodEnum: this.formaPagamentoSelecionada,
    };
  }

  enviarComprovanteBancario(documentoVM: any) {
    this.iniciarSpinner();
    if (!this.documentoValido || !this.arquivoOriginal) {
      this.toastr.warning('Precisa subir um documento(comprovante) valído.');
      this.pararSpinner();
      return;
    }
    this._pagamentoPropostaService.enviarComprovanteBancarioBeneficiario(documentoVM, this.arquivoOriginal).subscribe({
      next: async () => {
        this.toastr.success('Comprovante Enviado com sucesso!');
        //seguir para a etapa de analise pagamento (15)
        this.alterarStatusPagamento(true);
        this.pararSpinner();
        this.mensgemTemporaria = '';
        this.arquivoOriginal = null;
        this.modalService.hide();
      },
      error: err => {
        this.alterarStatusPagamento(false);
        this.pararSpinner();
        this.toastr.error(err.message);
      },
    });
  }

  async onSelecionarArquivo(event: Event) {
    this.iniciarSpinner();
    const inputElement = event.target as HTMLInputElement;

    // **Se o usuário cancelar, restaura o arquivo anterior diretamente no input**
    if (!inputElement.files || inputElement.files.length === 0) {
      this.restaurarArquivoNoInput();
      this.pararSpinner();
      return;
    }

    if (inputElement.files && inputElement.files.length > 0) {
      const file = inputElement.files[0];
      this.arquivoOriginal = file;
      const fileName = file.name.toLowerCase();

      const tamanhoArquivo = file.size / (1024 * 1024); // Converte para MB
      const tamanhoArquivoAceite = 5; //5MB
      const extensoesPermitidas = ['.doc', '.docx', '.pdf', '.jpg', '.jpeg', '.png']; // Formatos aceitos

      // Verifica se a extensão do arquivo é permitida
      const heFormatoValido = extensoesPermitidas.some(ext => fileName.endsWith(ext));

      if (tamanhoArquivo > tamanhoArquivoAceite) {
        inputElement.value = ''; // Reseta o input, impedindo a seleção
        this.mensgemTemporaria = 'Arquivo grande para Upload. Tamanho máximo para Upload é de: 5 MB.';
        this.toastr.warning('Tamanho máximo para Upload: 5 MB.');
        this.pararSpinner();
        return;
      } else {
        this.pararSpinner();
        this.mensgemTemporaria = '';
      }
      // Verifica se a extensão do arquivo é permitida
      if (!heFormatoValido) {
        // Se o formato for inválido, limpa o input e não processa o arquivo
        inputElement.value = '';
        this.toastr.warning('Formato de arquivo inválido! Apenas arquivos  .pdf, .jpg, .jpeg e .png são permitidos.');
        ((this.mensgemTemporaria =
          'Formato de arquivo inválido! Apenas arquivos  .pdf, .jpg, .jpeg e .png são permitidos.'),
          this.pararSpinner());
        return;
      }

      const reader = new FileReader();
      reader.onload = e => {
        //validar se é documento valido de acordo com o Tipo
        // const tipoDocumento = this.tipoDocumento;
        const tipoDocumento = 14; //comprovante Bancario
        this.validarDocumentoUpload(tipoDocumento, this.arquivoOriginal).subscribe({
          next: async (isValid: boolean) => {
            if (this.documentoValido) {
              const itemData = e.target?.result as string | ArrayBuffer;
              const format = this.documentoUploadHelper.getFileFormatFromFileName(file.name);
              this.uploadStatus = 'Upload concluído com sucesso!';
            }
          },

          error: async err => {
            this.pararSpinner();
            console.error(err);
          },
        });
      };
      reader.readAsDataURL(file);
      this.pararSpinner();
    }

    this.pararSpinner();
  }

  restaurarArquivoNoInput() {
    setTimeout(() => {
      const inputDocumentoUpload = document.getElementById('inputDocumentoUpload') as HTMLInputElement;

      if (inputDocumentoUpload && this.arquivoAnterior) {
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(this.arquivoAnterior);
        inputDocumentoUpload.files = dataTransfer.files;
      }
    }, 0);
  }

  validarDocumentoUpload(tipoDocumento: number, arquivo: any) {
    this.iniciarSpinner();
    const subject = new BehaviorSubject<boolean>(false);
    this.toastr.toastrConfig.preventDuplicates = true;
    this.documentoPropostaEntidadeService.validadeDocumento(tipoDocumento, arquivo).subscribe({
      next: async (data: any) => {
        this.documentoValido = true;
        this.mensgemTemporaria = data.data;
        this.toastr.success(data.data);
        this.pararSpinner(1000);
        subject.next(true);
      },
      error: async (err: {message: string}) => {
        this.pararSpinner(1000);
        this.documentoValido = false;
        this.mensgemTemporaria = err.message;
        this.toastr.warning(err.message || 'Erro ao validar arquivo.');
        return subject.next(false);
      },
    });
    return subject.asObservable();
  }

  adicionarDocumento(itemData: string | ArrayBuffer, format: string | null, file: File): any {
    const document: any = {
      dataUrl: itemData,
      format: format,
      fileName: file.name,
      file: file,
      size: file.size,
    };

    if (document.format == 'pdf') {
      document.visualizarDocumento = true;
    }
    return (this.documentoUpload = document);
  }

  voltarAreaCliente() {}

  fecharModal() {
    this.modalService.hide();
    this.limparFormulario();
  }

  limparFormulario() {
    this.isFlipped = false;
  }

  formatCardNumber(value: string): string {
    return value
      .replace(/\s/g, '')
      .replace(/(\d{4})/g, '$1 ')
      .trim();
  }

  formatExpiry(value: string): string {
    return value.replace(/\D/g, '').replace(/(\d{2})(\d)/, '$1/$2');
  }

  receberDadosDoBeneficiario(): Promise<any> {
    return new Promise((resolve, reject) => {
      this._compartilharDadosEntreComponentsService.obterDadosCompartilhados().subscribe(
        data => {
          this.dadosRecebidosDoBeneciarioVM = data && data;
          if (this.dadosRecebidosDoBeneciarioVM) {
            this.criarObjetoProdutoPagamento();
            resolve(this.dadosRecebidosDoBeneciarioVM);
          }
        },
        error => {
          reject(error);
        },
      );
    });
  }

  private criarObjetoProdutoPagamento() {
    this.dadosProdutoVM = {
      entidade: this.dadosRecebidosDoBeneciarioVM[0]?.dadosBeneficiario.branchCompanyName || '-',
      nomeProduto: this.dadosRecebidosDoBeneciarioVM[0]?.dadosBeneficiario?.productName || '-',
      operadora: this.dadosRecebidosDoBeneciarioVM[0]?.dadosBeneficiario?.operatorName || '-',
      totalDependentes:
        this.dadosRecebidosDoBeneciarioVM[0]?.dadosBeneficiario?.holderProposal?.dependentsProposal.length || 0,
      valorTitular: this.dadosRecebidosDoBeneciarioVM[0]?.dadosBeneficiario?.holderProposal?.priceValue || 0,
      valorTotalDependentes: this.calcularTotalDependentes() || 0,
      cobertura: this.dadosRecebidosDoBeneciarioVM[0]?.dadosBeneficiario?.coverageName || '-',
      taxaAdesao: this.dadosRecebidosDoBeneciarioVM[0]?.dadosBeneficiario?.membershipFee || 0,
      valorTotal: this.dadosRecebidosDoBeneciarioVM[0]?.dadosBeneficiario?.totalPriceValue || 0,
    };
  }

  calcularTotalDependentes(): number {
    const totalDependentes =
      this.dadosRecebidosDoBeneciarioVM[0]?.dadosBeneficiario?.holderProposal?.dependentsProposal.reduce(
        (acc: any, dep: {priceValue: any}) => acc + dep.priceValue,
        0,
      );
    return totalDependentes;
  }
  isFormValid() {
    this.isFormSubmited = true;
    return this.cardFormCredito.valid;
  }

  onFieldChange() {
    if (this.formTouched) {
      this.errorMessage = !this.isFormValid();
    }
  }

  //visa cartao teste - 4539620659922097 cvv 123 validade 12/2030
  concluirPagamento() {
    this.iniciarSpinner();
    if (!this.isFormValid()) {
      this.errorMessage = true;
      this.toastr.warning('Verifique os campos obrigatórios.');
      this.pararSpinner();
      return;
    }
    // Buscar a chave pública do PagBank
    this._pagamentoPropostaService.listarChavePagBank().subscribe({
      next: (response: any) => {
        const publicKey = response.data || response.publicKey || response;

        if (!publicKey) {
          this.pararSpinner();
          this.toastr.error('Não foi possível obter a chave pública do PagBank.');
          return;
        }
        const cardNumber = this.cardFormCredito.value.cardNumber.replace(/\s/g, '');
        const mesValidade = this.cardFormCredito.value.expiry.substring(0, 2);
        const anoValidade = this.cardFormCredito.value.expiry.substring(2, 6);
        const holderName = this.cardFormCredito.value.holderName;
        const securityCode = this.cardFormCredito.value.securityCode;
        const cpfHolder = this.cardFormCredito.value.cpfHolder.replace(/\D/g, '');
        const installments = this.cardFormCredito.value.installments;

        // Criptografar o cartão usando o SDK do PagBank
        try {
          const card = window.PagSeguro.encryptCard({
            publicKey: publicKey,
            holder: holderName,
            number: cardNumber,
            expMonth: mesValidade,
            expYear: anoValidade,
            securityCode: securityCode,
          });

          if (card.hasErrors) {
            this.pararSpinner();
            this.toastr.error('Erro ao criptografar o cartão. Verifique os dados informados.');
            console.log('Erros de criptografia:', card.errors);
            return;
          }

          const encryptedCard = card.encryptedCard;
          const holderEmail = this.dadosRecebidosDoBeneciarioVM[0]?.dadosBeneficiario?.holderProposal?.email;
          const propostaId = this._activeRoute.snapshot.paramMap.get('idProposta') || '';
          const valorTotal = this.dadosProdutoVM?.taxaAdesao || 0;
          const uuid = crypto.randomUUID();
          // Preparar os dados para enviar apenas o cartão criptografado
          const dadosPagamento = {
            referenceId: `proposal-${propostaId}`,
            description: 'Pagamento de Taxa de Adesão',
            amount: valorTotal,
            holderName: holderName,
            holderEmail: holderEmail,
            cpfHolder: cpfHolder,
            installments: installments,
            encryptedCard: encryptedCard,
            propostaId: propostaId,
          };

          this._pagamentoPropostaService.credito(dadosPagamento).subscribe({
            next: (dataVM: any) => {
              this.formaPagamentoSelecionada = this._metodoPagamento.CREDITO;
              //seguir para a etapa de analise pagamento (15)
              this.alterarStatusPagamento(true);
              //ir para a tela de Analise de pagamento.
              this.fecharModal();
              this.toastr.success('Pagamento Realizado com sucesso!');
              this.pararSpinner();
            },

            error: (e: any) => {
              this.pararSpinner();
              this.toastr.toastrConfig.preventDuplicates = true;

              this.toastr.error(e.message.message || e.message);
            },
          });
        } catch (error) {
          this.pararSpinner();
          this.toastr.error('Erro ao processar o pagamento. Tente novamente.');
          console.error('Erro ao criptografar cartão:', error);
        }
      },
      error: (err: any) => {
        this.pararSpinner();
        this.toastr.error('Erro ao buscar a chave pública do PagBank.');
        console.error('Erro ao buscar chave pública:', err);
      },
    });
  }

  validarNumeroCartao(control: AbstractControl): {[key: string]: boolean} | null {
    const numero = control.value?.replace(/\D/g, ''); // Remove caracteres não numéricos

    if (!numero) {
      return null; // Se o campo estiver vazio, não valida
    }

    let soma = 0;
    let deveDobrar = false;

    // Algoritmo de Luhn
    for (let i = numero.length - 1; i >= 0; i--) {
      let digito = parseInt(numero.charAt(i), 10);

      if (deveDobrar) {
        digito *= 2;
        if (digito > 9) {
          digito -= 9; // Subtrai 9 se o resultado for maior que 9
        }
      }

      soma += digito;
      deveDobrar = !deveDobrar; // Alterna entre dobrar e não dobrar
    }

    return soma % 10 === 0 ? null : {numeroInvalido: true}; // Retorna erro se não for válido
  }

  listaParcelasCartaoCredito() {
    this.iniciarSpinner();
    const idProposta = this._activeRoute.snapshot.paramMap.get('idProposta');
    this._pagamentoPropostaService.listaParcelasCartao(idProposta).subscribe({
      next: (dataVM: any) => {
        this._listaParcelasCartaoCredito = dataVM;
        this.pararSpinner();
      },

      error: (e: any) => {
        this.pararSpinner();
        this.toastr.toastrConfig.preventDuplicates = true;
      },
    });
  }

  clicarNaAba(numeroAba: number) {
    this.tabService.definirAbaAtivaPorNumero(numeroAba);

    this.pararSpinner(1000);
  }

  buscarDadosPagamentoPorProposta() {
    this.iniciarSpinner();
    const idProposta = this._activeRoute.snapshot.paramMap.get('idProposta');
    this._pagamentoPropostaService
      .buscarDadosPagamentoPorProposta(idProposta)
      .pipe(
        finalize(() => {
          this.pararSpinner();
        }),
      )
      .subscribe({
        next: (dataVM: any) => {
          this.formaPagamentoSelecionada = dataVM?.paymentMethod;
          if (dataVM?.proposalStep == this.propostaEnum.PAGAMENTO_CONFIRMADO) this.somenteLeituraStep = true;
        },

        error: (e: any) => {
          this.pararSpinner();
          this.toastr.toastrConfig.preventDuplicates = true;
        },
      });
  }

  public get ehColaborador(): boolean {
    return this._router.url.includes('colaborador');
  }

  abrirModalDocumentoFinal() {
    this.heOdonto = TipoProduto_E_OperadoraComponent.isOdonto(
      this.dadosRecebidosDoBeneciarioVM[0].dadosBeneficiario.productType,
    );
    if (!this.dadosOperadoraDM) {
      if (this.dadosRecebidosDoBeneciarioVM?.[0]?.dadosBeneficiario) {
        this.dadosOperadoraDM = {
          nomeEntidade: this.dadosRecebidosDoBeneciarioVM[0].dadosBeneficiario?.branchCompanyName,
          operatorObject: this.dadosRecebidosDoBeneciarioVM[0].dadosBeneficiario.operatorObject,
        };
      }
    }
    const dadosOperadora = TipoProduto_E_OperadoraComponent.getByCnpj(this.dadosOperadoraDM.operatorObject.cnpj);

    const titular =
      this.dadosRecebidosDoBeneciarioVM[0].dadosBeneficiario &&
      this.dadosRecebidosDoBeneciarioVM[0].dadosBeneficiario.holderProposal;
    this.idProposta = this.dadosRecebidosDoBeneciarioVM[0].dadosBeneficiario.id;
    this.listaIdBeneficiarios.push(titular.id);
    titular.dependentsProposal.forEach((dependente: any) => {
      this.listaIdBeneficiarios.push(dependente.id);
    });

    if (!titular) {
      return;
    }

    const assinaturaDocumentoFinal =
      titular &&
      titular.additiveSignatures?.find(
        (assinatura: any) => assinatura.modalType === TipoModalAssinaturaEnum.DOCUMENTO_FINAL,
      );

    //RN - So deve abrir o modal se nao tiver alguma assinatatura(Li e concordo com o documento e clicar em Avancar),
    // ou seja se ele ja assinar o documento(Modal) naa deve exibir este modal.
    const podeAbrirModal = !assinaturaDocumentoFinal;

    if (this.heOdonto) {
      this.tratarModalOdonto(dadosOperadora.tipo);
    } else {
      this.tratarModalSaude(this.dadosOperadoraDM.nomeEntidade);
    }

    if (podeAbrirModal && !this.ehColaborador) {
      this.modalDocFinalRef = this.modalService.show(this.modalDocFinal, {
        backdrop: 'static',
        class: 'modal-xl',
        id: 'modalDocFinal',
      });
    }
  }

  async assinarDocFinal(): Promise<any> {
    try {
      this.iniciarSpinner();
      this.modalDocFinalRef?.hide();

      if (this.checkboxDocFinal) {
        this.objModalDocFinal = {
          proposalId: this.dadosRecebidosDoBeneciarioVM[0].dadosBeneficiario.id,
          proposalType: this.dadosRecebidosDoBeneciarioVM[0].dadosBeneficiario.proposalType,
          modalType: TipoModalAssinaturaEnum.DOCUMENTO_FINAL,
          holderProposalId: this.dadosRecebidosDoBeneciarioVM[0].dadosBeneficiario.holderProposal.id,
        };
        this._propostaCotacaoService
          .assinarModaisAditivos(this.objModalDocFinal)
          .pipe(finalize(() => this.pararSpinner()))
          .subscribe({
            next: async data => {
              this.toastr.success('Documento assinado com sucesso.');
              this.toastr.toastrConfig.preventDuplicates = true;
              this.modalDocFinalRef?.hide();
            },
            error: error => {
              this.toastr.error('Falha ao assinar o documento final.');
              this._errorLoggingService.logError('Erro ao assinar o documento final da proposta externa', error, {
                contexto: 'Falha para assinar o modal de documento final da proposta externa na aba de documentos.',
                dadosEnviados: {
                  ObjetoEnviado: this.objModalDocFinal,
                },
              });
            },
          });
      }
    } catch (error) {
      this.toastr.error('Falha ao assinar o documento final.');
      return false;
    } finally {
      this.pararSpinner();
    }
  }
  resetarTodasPropsOdonto() {
    this.entidades.heOdontoPrev = false;
    this.entidades.heUniOdonto = false;
    this.entidades.heUnimedOdonto = false;
  }

  tratarModalSaude(nomeEntidade: any) {
    const entidadeConfig = EntidadeConfig.getConfig(nomeEntidade || '');

    this.entidades.heUdemo = entidadeConfig.tipo === EntidadeEnum.UDEMO;
    // ESTIPULADO
    this.entidades.heUnimedFesp =
      entidadeConfig.tipo !== EntidadeEnum.UDEMO && entidadeConfig.tipo !== EntidadeEnum.APASE;

    //NAO ESTIPULADO
    this.entidades.heApase = entidadeConfig.tipo === EntidadeEnum.APASE;
    this.entidades.heAbraWeb = entidadeConfig.tipo === EntidadeEnum.ABRAWEB;
    this.entidades.heAbje = entidadeConfig.tipo === EntidadeEnum.ABJE;
    this.entidades.heAdservip = entidadeConfig.tipo === EntidadeEnum.ADSERVIP;
    this.entidades.heAfuspen = entidadeConfig.tipo === EntidadeEnum.AFUSPEN;
    this.entidades.heCpp = entidadeConfig.tipo === EntidadeEnum.CPP;
    this.entidades.heCrosp = entidadeConfig.tipo === EntidadeEnum.CROSP;
    this.entidades.heSasp = entidadeConfig.tipo === EntidadeEnum.SASP;
    this.entidades.heSindinutri = entidadeConfig.tipo === EntidadeEnum.SINDINUTRI;
    this.entidades.heTecnologos = entidadeConfig.tipo === EntidadeEnum.TECNOLOGOS;
    this.entidades.heAastpj = entidadeConfig.tipo === EntidadeEnum.AASTPJ;
  }

  tratarModalOdonto(dadosOperadora: any) {
    this.resetarTodasPropsOdonto();
    switch (dadosOperadora) {
      case TipoProduto_E_OperadoraEnum.ODONTOPREV:
        this.entidades.heOdontoPrev = true;
        break;
      case TipoProduto_E_OperadoraEnum.UNIODONTO:
        this.entidades.heUniOdonto = true;
        break;
      case TipoProduto_E_OperadoraEnum.UNIMED_ODONTO:
        this.entidades.heUnimedOdonto = true;
        break;
    }
  }
  //5240 0829 7562 2454 CVV-123 VALIDADE-12/30
  podeAnexarComprovante(dataVM: any): boolean {
    // Se for TED,BOLETO ou pix e for vendedor da Geia ele faz o anexo e apos o anexo vai para a etapa de analise do pagamento
    // Se for cartao ele faz a mesma coisa sem a necessidade do anexo.
    if (
      dataVM[0]?.dadosBeneficiario?.isGeia &&
      (this.formaPagamentoSelecionada == this._metodoPagamento.BOLETO ||
        this.formaPagamentoSelecionada == this._metodoPagamento.TED ||
        this.formaPagamentoSelecionada == this._metodoPagamento.PIX)
    ) {
      return true;
    } else return false;
  }

  // Envia informacao da prop isAnalisePagamento para o pai(app-proposta-associado-entidade)
  alterarStatusPagamento(novoEstado: boolean) {
    this.tabService.definirAbaAtivaPorNumero(PropostaExternaEnum.PAGAMENTO);
    // Define o step atual no serviço
    this.tabService.definirStepAtual(PropostaExternaEnum.PAGAMENTO);
    this.isAnalisePagamento = novoEstado;
    this.isAnalisePagamentoChange.emit(novoEstado);
  }

  async imprimirBoleto() {
    this.iniciarSpinner();

    setTimeout(async () => {
      const element = document.getElementById('section-boleto');
      if (!element) {
        this.pararSpinner();
        return;
      }

      const canvas = await html2canvas(element, {scale: 2});

      const pdf = new jsPDF('p', 'mm', 'a4');
      const pageWidth = 210;
      const pageHeight = 297;

      const imgWidth = pageWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      // Altura de cada parte (2 páginas)
      const halfHeight = canvas.height / 2;

      // ===== Página 1 =====
      const canvasPage1 = document.createElement('canvas');
      canvasPage1.width = canvas.width;
      canvasPage1.height = halfHeight;

      const ctx1 = canvasPage1.getContext('2d')!;
      ctx1.drawImage(canvas, 0, 0, canvas.width, halfHeight, 0, 0, canvas.width, halfHeight);

      const imgData1 = canvasPage1.toDataURL('image/png');
      const page1Height = (halfHeight * imgWidth) / canvas.width;

      pdf.addImage(imgData1, 'PNG', 0, 0, imgWidth, page1Height);

      // ===== Página 2 =====
      const canvasPage2 = document.createElement('canvas');
      canvasPage2.width = canvas.width;
      canvasPage2.height = halfHeight;

      const ctx2 = canvasPage2.getContext('2d')!;
      ctx2.drawImage(canvas, 0, halfHeight, canvas.width, halfHeight, 0, 0, canvas.width, halfHeight);

      const imgData2 = canvasPage2.toDataURL('image/png');
      const page2Height = (halfHeight * imgWidth) / canvas.width;

      pdf.addPage();
      pdf.addImage(imgData2, 'PNG', 0, 0, imgWidth, page2Height);

      pdf.save(`boleto_${this.dadosBoleto.sacadoNome}_${new Date().toISOString().slice(0, 10)}.pdf`);

      this.pararSpinner();
    }, 300);
  }
}
